import { normalize_portal_url } from "@/setup/connect/portal_url"

interface ConnectionInfoSectionProps {
  data?: Record<string, unknown>
  className?: string
}

export function ConnectionInfoSection({ data, className }: ConnectionInfoSectionProps) {
  if (!data) return null

  const portalUrl = typeof data.portal_url === "string" ? data.portal_url.trim() : ""
  const emailFrom = typeof data.email_from === "string" ? data.email_from.trim() : ""
  const description = typeof data.description === "string" ? data.description.trim() : ""

  if (!portalUrl && !emailFrom && !description) {
    return null
  }

  const normalizedPortalUrl = portalUrl ? normalize_portal_url(portalUrl) : ""

  return (
    <dl class={`space-y-3 text-sm ${className ?? ""}`}>
      {normalizedPortalUrl && (
        <div>
          <dt class="text-gray-500">Portal URL</dt>
          <dd class="text-gray-900 break-all">
            <a
              href={normalizedPortalUrl}
              target="_blank"
              rel="noopener noreferrer"
              class="text-indigo-600 hover:text-indigo-800">
              {normalizedPortalUrl}
            </a>
          </dd>
        </div>
      )}
      {emailFrom && (
        <div>
          <dt class="text-gray-500">Checks emailed from</dt>
          <dd class="text-gray-900">{emailFrom}</dd>
        </div>
      )}
      {description && (
        <div>
          <dt class="text-gray-500">Description</dt>
          <dd class="text-gray-900 whitespace-pre-wrap">{description}</dd>
        </div>
      )}
    </dl>
  )
}
